import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

// Publishing — delete-post confirmation (item 1, 2026-07-28). Publishing-local
// (the module boundary keeps us off broadcasts' near-identical modal), built on
// the shadcn Dialog so Radix owns the overlay / focus trap / Esc.
//
// The copy branches on `scheduled`: a scheduled post's deletion CANCELS the live
// provider schedule, which the AM should be told before confirming. Default focus
// lands on Cancel (not the destructive action). Stays open on error so a Zernio
// cancel failure is visible rather than dismissed.

export function ConfirmDeletePostModal({
  scheduled,
  busy,
  errorText,
  onConfirm,
  onCancel,
}: {
  /** The post is live in the provider queue — deletion cancels that schedule. */
  scheduled: boolean;
  busy?: boolean;
  errorText?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        // Esc / overlay / close → cancel, unless mid-delete.
        if (!open && !busy) onCancel();
      }}
    >
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Delete this post?</DialogTitle>
          <DialogDescription>
            {scheduled
              ? 'This post is scheduled — deleting it cancels the schedule with the provider so it won’t publish. This can’t be undone.'
              : 'This draft will be removed. This can’t be undone.'}
          </DialogDescription>
        </DialogHeader>
        {errorText && <p className="text-sm text-destructive">{errorText}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {busy ? 'Deleting…' : 'Delete post'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
